import React, {Component} from "react";
import {connect} from "react-redux";
import 'moment-timezone';
import {withTranslation} from "react-i18next";

import {fetchLotto5RecentDraw} from "../../store/rootAction";
import {JackpotValue} from "../jackpot/JackpotValue";
import {getShortBetType} from "../../utils/tickets/printUtils";
import RefreshButton from "../../utils/RefreshButton";
import {isOddEven} from "../../constants/general";

class DrawResult extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {t, lastDraws} = this.props;
        return (
            <>
                {
                    lastDraws.length > 0 ? <>

                            <div
                                className="col no-padding-div header-div-title header-text header-div-blue-light block-header ">
                                <span className="text-black kh-font-bold">{t("labels:common.lastGame")}</span>
                                <RefreshButton
                                    onClick={() => {
                                        this.setState({imageResultRotate: "rotate"})
                                        this.props.fetchLotto5RecentDraw()
                                            .then(() => {
                                                setTimeout(() => {
                                                    this.setState({imageResultRotate: ""})
                                                }, 300)
                                            }).catch(() => {
                                            setTimeout(() => {
                                                this.setState({imageResultRotate: ""})
                                            }, 300)
                                        })
                                    }}
                                    className={this.state.imageResultRotate}
                                />
                            </div>

                            <div className="col no-padding-div header-div-title header-text header-div-white tb-lotto">
                                <table className="table fade-in table-striped">
                                    <tbody>
                                    {
                                        lastDraws.map((item, index) => {
                                            return (
                                                <tr className="fade-in table-draw-result" key={index}>
                                                    <td className="text-left font-weight-bold w-last-draw">{item.drawLabel}</td>
                                                    <td className="text-left font-weight-bold"><span
                                                        className={"kh-font-bold left-bet-type-" + item.underOverCode}>{t("labels:betPrefix.S_" + getShortBetType(item.underOverCode))}
                                                    </span>
                                                        {isOddEven && <span> | </span>}
                                                        {isOddEven && <span
                                                            className={"kh-font-bold left-bet-type-" + item.oddEvenCode}>{t("labels:betPrefix." + item.oddEvenCode)}
                                                    </span>}
                                                        <span> | </span>
                                                        <span
                                                            className={"kh-font-bold left-bet-type-" + item.number}> {t("labels:ticket.number")} {t("labels:betPrefix." + item.number)}​
                                                    </span>
                                                        <span>   </span>{item.isJackpot ? <JackpotValue {...item}/> : ""}
                                                        <span> | </span><b>{item.result}</b>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </>
                        : null
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    lastDraws: state.lotto5.lastDraws
})


export default withTranslation()(connect(
    mapStateToProps,
    {fetchLotto5RecentDraw}
)(DrawResult));
